import getQueryParams from '@/services/utils/get-query-params'

export default function setQueryParamsToSessionStorage() {
  const allQueryParams = getQueryParams(window.location.href)
  if (Object.keys(allQueryParams).length) {
    sessionStorage.setItem('registration_params', JSON.stringify(allQueryParams))
  }
}
